import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { buttonText, labelText } from "../../lib/constants";

export const Filters = ({
  onSubmit,
  defaultValues = {
    name_therapist: "",
  },
}) => {
  const [filters, setFilters] = React.useState(defaultValues);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(filters);
  };

  const handleInputChange = (e) => {
    setFilters({
      name_therapist: e.target.value || "",
    });
  };

  return (
    <Card className="mb-3">
      <Card.Body>
        <Card.Title>{labelText.filters}</Card.Title>
        <Form onSubmit={handleSubmit}>
          <Row className="mb-2 g-3">
            <Col xs={12} sm={8} md={9}>
              <Form.Label>{labelText.search_name_therapist}</Form.Label>
              <Form.Control
                type="text"
                id="name_therapist"
                aria-describedby="generic_field"
                value={filters.name_therapist}
                onChange={handleInputChange}
                placeholder={labelText.search_name_therapist_placeholder}
              />
            </Col>
            <Col xs={12} sm={4} md={2} className="d-flex align-items-end">
              <Button type="submit" className="w-100">{buttonText.filter}</Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};
